import { SvgData } from "../../model/SvgData";
import { IconosSlider } from "./IconosSlider";
import { getConfig } from "./ConfigSlider";
import { IconosStatic } from "./IconosStatic";
import { GenericComponentProps } from "../../model/GenericComponentProps";
import { ErrorBoundary } from "../ErrorBoundary";
import { useDevice } from "@bpba/ui-components";

export const IconosSliderComponent = (
  props: GenericComponentProps<SvgData>
) => {
  const device = useDevice();
  const config = getConfig(device, props.data);

  if (!config) return <></>;

  return (
    <ErrorBoundary>
      {config?.slides.length > 0 ? (
        <IconosSlider config={config} {...props} />
      ) : (
        <IconosStatic {...props} />
      )}
    </ErrorBoundary>
  );
};
